import { oneOf } from "prop-types";

export const layoutTypes = oneOf([
  "default",
  "media", // for infographics, image blocks, and data-visualization-custom
  "full-bleed", // for components within a full-bleed container
  "rich-text", // for rich text blocks
  "accordion", // for accordions
]).isRequired;

export const markerTypes = oneOf([
  "plainFlagWithSelection",
  "squareFlagWithSelection",
  "squareFlagWithOverlay",
]).isRequired;

export const highlightTypes = oneOf(["selection", "overlay"]).isRequired;
